// src/components/MessageModal.js
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './messagemodal.scss';

export const MessageModal = ({ isOpen, onClose, title, message, icon, buttonText }) => {
    //console.log('📦 MessageModal riceve:', { isOpen, title, message, icon, buttonText });
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div 
                    className="message-modal-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div 
                        className="message-modal-content"
                        initial={{ scale: 0.8, y: 50 }}
                        animate={{ scale: 1, y: 0 }}
                        exit={{ scale: 0.8, y: 50 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="message-icon">{icon || '📧'}</div>
                        <h2>{title || 'Attenzione'}</h2>
                        <p>{message}</p>
                        <button className="message-button" onClick={onClose}>
                            {buttonText || 'Ho capito'}
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
